module.exports = __webpack_public_path__ + "static/media/postcard.a261d548.svg";